"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateStudentsMapper = exports.updateGroupsMapper = exports.sortClassesAndGroupsStudents = exports.sortByStudentFullName = exports.sortByGroupName = exports.mapStudents = exports.mapClassesAndGroups = exports.getStudentFullName = exports.getAudienceData = void 0;
const getStudentFullName = student => {
  return student ? student.lastName + ' ' + student.firstName : '';
};
exports.getStudentFullName = getStudentFullName;
const getAudienceData = (groups, audienceID) => {
  const audienceGroups = groups.filter(group => group.groupType !== 'audience').map(group => {
    return group.id;
  });
  const audienceSingleStudents = groups.filter(group => group.groupType === 'audience');
  const audienceStudents = audienceSingleStudents[0]?.students.map(student => {
    return {
      ContextGroupID: student.contextGroupId,
      UserID: student.id
    };
  });
  const audienceData = {
    AudienceId: audienceID,
    Groups: audienceGroups,
    SingleUsers: audienceStudents
  };
  return audienceData;
};
exports.getAudienceData = getAudienceData;
const mapClassesAndGroups = (group, userId, mappers) => {
  let mapper;
  if (group.groupType !== 'audience') {
    mapper = group.groupType === 'class' ? mappers.classes : mappers.groups;
    if (!mapper[group.id]) {
      mapper[group.id] = {
        group: {
          ...group
        },
        teacherIds: [],
        studentIds: []
      };
    }
    mapper[group.id].teacherIds.push(userId);
  }
};
exports.mapClassesAndGroups = mapClassesAndGroups;
const mapStudents = (group, mappers) => {
  group.students?.forEach(student => {
    if (!mappers.students[student.id]) {
      mappers.students[student.id] = {
        student: {
          ...student
        },
        groupIds: [],
        classIds: []
      };
    }
    if (group.groupType === 'audience') {
      mappers.singleStudents[student.id] = {
        student: {
          ...student
        },
        groupIds: [],
        classIds: [],
        audienceId: group.id
      };
      mappers.students[student.id].audienceId = group.id;
    } else {
      let mapper = group.groupType === 'class' ? mappers.classes : mappers.groups;
      mapper[group.id].studentIds.push(student.id);
      if (group.groupType === 'class') {
        mappers.students[student.id].classIds.push(group.id);
      } else {
        mappers.students[student.id].groupIds.push(group.id);
      }
    }
  });
};
exports.mapStudents = mapStudents;
const sortClassesAndGroupsStudents = (group, mappers) => {
  let mapper = group.groupType === 'class' ? mappers.classes : mappers.groups;
  if (group.groupType !== 'audience') {
    mapper[group.id].studentIds.sort((a, b) => {
      return getStudentFullName(mappers.students[a].student) < getStudentFullName(mappers.students[b].student) ? -1 : getStudentFullName(mappers.students[a].student) > getStudentFullName(mappers.students[b].student) ? 1 : 0;
    });
  }
};
exports.sortClassesAndGroupsStudents = sortClassesAndGroupsStudents;
const sortByGroupName = mapper => {
  return Object.keys(mapper).sort((a, b) => {
    return mapper[a].group.name < mapper[b].group.name ? -1 : mapper[a].group.name > mapper[b].group.name ? 1 : 0;
  });
};
exports.sortByGroupName = sortByGroupName;
const sortByStudentFullName = mapper => {
  return Object.keys(mapper).sort((a, b) => {
    return getStudentFullName(mapper[a].student) < getStudentFullName(mapper[b].student) ? -1 : getStudentFullName(mapper[a].student) > getStudentFullName(mapper[b].student) ? 1 : 0;
  });
};
exports.sortByStudentFullName = sortByStudentFullName;
const updateGroupsMapper = (group, groupsMapper, userIds, studentsSelectorTempData) => {
  let newGroupsMapper = {
    ...groupsMapper
  };
  if (!newGroupsMapper[group.id]) {
    newGroupsMapper[group.id] = {
      group: {
        ...group
      },
      teacherIds: [],
      studentIds: []
    };
  } else {
    newGroupsMapper[group.id] = {
      ...newGroupsMapper[group.id],
      ...group
    };
  }
  newGroupsMapper[group.id].teacherIds = [...userIds];
  newGroupsMapper[group.id].studentIds = [...studentsSelectorTempData.selectedStudentsIds];
  userIds.forEach(id => {
    if (newGroupsMapper[group.id].teacherIds.indexOf(id) < 0) {
      newGroupsMapper[group.id].teacherIds.push(id);
    }
  });
  return newGroupsMapper;
};
exports.updateGroupsMapper = updateGroupsMapper;
const updateStudentsMapper = (group, studentsMapper, newGroupsMapper, studentsSelectorTempData) => {
  let newStudentsMapper = {
    ...studentsMapper
  };
  studentsSelectorTempData.selectedStudentsIds.forEach(id => {
    if (newGroupsMapper[group.id].studentIds.indexOf(id) < 0) {
      newGroupsMapper[group.id].studentIds.push(id);
    }
    if (newStudentsMapper[id]) {
      if (!newStudentsMapper[id].groupIds) {
        newStudentsMapper[id].groupIds = [];
      }
      if (newStudentsMapper[id].groupIds.indexOf(group.id) < 0) {
        newStudentsMapper[id].groupIds.push(group.id);
      }
    }
  });
  return newStudentsMapper;
};
exports.updateStudentsMapper = updateStudentsMapper;